<template>

  <el-table :data="tasks" style="font-size:12px;width: 100%" row-key="id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
    <el-table-column prop="name" label="任务名称" width="180" align="left" fixed="left">
      <template #header>
        <!-- 名称标题 -->
        <div style="padding-left: 90px" >
          任务名称
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="responsible" label="责任人" width="100" align="center" fixed="left"></el-table-column>
    <el-table-column prop="progress" label="进度" width="50" align="center" fixed="left">
      <template #default="scope">
        <div style="color: white;padding-left:2px;background-color: #95d475">{{scope.row.progress}}%</div>
      </template>
    </el-table-column>

    <!-- 右侧甘特图部分 -->
    <el-table-column label="甘特图" min-width="200">
      <template #header>
        <!-- 年月标题 -->
        <div class="gantt-title-year-month">
          <div v-for="(month, index) in monthsRange" :key="index" class="gantt-title-month" :style="{ width: month.width + 'px' }">
            {{ month.yearMonth }}
          </div>
        </div>
        <!-- 日期标题 -->
        <div class="gantt-title-days">
          <div v-for="(day, index) in dateRange" :key="index" class="gantt-title-day" :style="{ left: calculateLeft(day) + 'px' }">
            {{ getFormatDay(day)}}
          </div>
        </div>
      </template>

      <template #default="scope">
        <div class="gantt-chart" style="width: 600px">
          <!-- 显示甘特图的日期背景 -->
          <div class="gantt-background">
            <div
                v-for="date in dateRange"
                :key="date"
                class="gantt-date-cell"
                :style="{ left: calculateLeft(date) + 'px' }"
            >
            </div>
          </div>
          <!-- 显示甘特条 -->
          <div
              v-for="bar in scope.row.bars"
              :key="bar.id"
              :class="getGanttBarClass(bar.styleClass)"
              :style="{
              left: calculateLeft(bar.startDate) + 'px',
              width: calculateWidth(bar.startDate, bar.endDate) + 'px'
            }"
          >
            <span class="bar-label">{{ bar.name }}</span>
          </div>
        </div>
      </template>
    </el-table-column>
  </el-table>

</template>

<style scoped>
.el-table .cell{
  padding: 0 4px!important;
}
.el-table__cell
{
  padding: 0px 0px!important;
}
</style>

<script>

import dayjs from 'dayjs';

export default {
  name: 'GanttDemo3',
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      config:{
        leftColumns : [],
        showActionColumn: true
      },
      startDate: dayjs('2023-04-01'),
      endDate: dayjs('2023-05-31'),
      days: 61,
      tasks: [
        {
          id: 1,
          name: '数据库设计',
          responsible: '张三',
          progress: 50,
          bars: [
            {
              id: 'bar1',
              name: '数据库设计',
              startDate: '2023-04-02',
              endDate: '2023-04-10',
              color: '#7cb5ec',
              styleClass: 'gantt-bar-plan'
            },
            {
              id: 'bar2',
              name: '',
              startDate: '2023-04-04',
              endDate: '2023-04-13',
              color: '#90ed7d',
              styleClass: 'gantt-bar-actual'
            }
          ]
        },
        {
          id: 2,
          name: '基础数据导入',
          responsible: '李四',
          progress: 35,
          bars: [
            {
              id: 'bar1',
              name: '基础数据导入',
              startDate: '2023-04-18',
              endDate: '2023-04-28',
              color: '#7cb5ec',
              styleClass: 'gantt-bar-plan'
            },
            {
              id: 'bar2',
              name: '',
              startDate: '2023-04-18',
              endDate: '2023-04-29',
              color: '#90ed7d',
              styleClass: 'gantt-bar-actual'
            }
          ]
        }
        // 其他任务...
      ]
    }
  },
  computed: {
    dateRange: function () {
      const dates = [];
      let current = this.startDate;
      while (current.isBefore(this.endDate) || current.isSame(this.endDate, 'day')) {
        dates.push(current.format('YYYY-MM-DD'));
        current = current.add(1, 'day');
      }
      return dates;
    },
    monthsRange: function (){
      const months = [];
      let current = this.startDate.startOf('month');
      while (current.isBefore(this.endDate) || current.isSame(this.endDate, 'month')) {
        const monthEnd = current.endOf('month').isBefore(this.endDate) ? current.endOf('month') : this.endDate;
        months.push({
          yearMonth: current.format('YYYY-MM'),
          width: (monthEnd.diff(current, 'day') + 1) * 20, // 每天20px的间距
        });
        current = current.add(1, 'month').startOf('month');
      }
      return months;
    }
  },
  methods: {
    getFormatDay(date){
      return dayjs(date).format('D')
    },
    calculateLeft(date){
      const baseDate = this.startDate;
      const current = dayjs(date);
      return current.diff(baseDate, 'day') * 20; // 每天20px的间距
    },
    calculateWidth(startDate, endDate){
      const start = dayjs(startDate);
      const end = dayjs(endDate);
      return (end.diff(start, 'day') + 1) * 20; // 每天20px的间距
    },
    getGanttBarClass(styleClass){
      if(!styleClass){
        return 'gantt-bar';
      }
      return styleClass;
    },
    initGantt() {

    }
  },
  mounted: function () {
    this.initGantt();
  }
}
</script>

<style scoped>

.el-table .cell{
  padding: 0 4px;
}

.el-table .el-table__cell
{
  padding: 0;
}



.el-progress-bar__inner{
  border-radius: 0;
}
.el-progress-bar__outer{
  border-radius: 0;
}


.gantt-chart {
  position: relative;
  height: 23px;
}

.gantt-background {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  height: 24px;
  line-height: 24px;
}

.gantt-title-year-month {
  display: flex;
  font-weight: normal;
}

.gantt-title-month {
  text-align: center;
  padding: 2px;
  border: 1px solid #ebeef5;
  background-color: #f5f7fa;
}

.gantt-title-days {
  position: relative;
  display: flex;
  height: 20px;
  border-bottom: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.gantt-title-day {
  position: absolute;
  text-align: center;
  width: 20px;
  font-size: 10px;
  color: #606266;
  border-right: 1px solid #dcdfe6;
}

.gantt-date-cell {
  position: absolute;
  top: 0;
  height: 24px;
  width: 20px;
  text-align: center;
  font-size: 10px;
  border: 1px solid #dcdfe6;
}

.gantt-bar {
  position: absolute;
  background-color: #7cb5ec;
  top: 2px;
  height: 20px;
  border-radius: 0px;
  color: white;
  text-align: center;
  line-height: 20px;
  padding: 0 4px;
  font-size: 12px;
}

.gantt-bar-plan {
  position: absolute;
  background-color: #7cb5ec;
  top: 2px;
  height: 20px;
  border-radius: 0px;
  color: white;
  text-align: center;
  line-height: 20px;
  padding: 0 4px;
  font-size: 12px;
}

.gantt-bar-actual {
  position: absolute;
  background-color: #90ed7d;
  top: 22px;
  height: 2px;
  border-radius: 0px;
  color: white;
  text-align: center;
  line-height: 2px;
  padding: 0 4px;
  font-size: 12px;

}

.bar-label {
  white-space: nowrap;
}
</style>